import { render } from "./facture-payments.vue?vue&type=template&id=78e35d66&scoped=true"
import script from "./facture-payments.vue?vue&type=script&lang=js"
export * from "./facture-payments.vue?vue&type=script&lang=js"

import "./facture-payments.vue?vue&type=style&index=0&id=78e35d66&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78e35d66"]])

export default __exports__